import { COLOR_BLACK, COLOR_MAIN } from "../../data/colors/Colors";
import { CustomTextView } from "./CustomTextView";

interface props {
  title: string;
  size?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  color?: string
}

export const TitleView: React.FC<props> = ({ title, size = "h4", color = COLOR_BLACK }: props) => {
  return <CustomTextView text={title} fontWeight="bold" variant={size} textColor={color}/>;
};
